var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.201,
    height: 20.794,
    viewBox: "0 0 19.201 20.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Driver",
    d: "M167.332,150.857l.572-.094a1.686,1.686,0,0,1,1.466.473.88.88,0,0,1,.312.392,4,4,0,0,0,2.949,2.29c.592.117,1.676.149,2.119-.36a.876.876,0,0,1,1.318,1.153,4.007,4.007,0,0,1-3.773.93,6.082,6.082,0,0,1-2.005-.784l.116.7-2.719,4.208a1.684,1.684,0,0,1-.785-1.161l-.96-5.808a1.691,1.691,0,0,1,1.389-1.939Zm1.146-5.287a2.132,2.132,0,1,1-2.132,2.132A2.132,2.132,0,0,1,168.478,145.57Zm-5.248,7.968a.875.875,0,0,1,1.722-.308c0,.009.515,2.907.991,5.34a2.648,2.648,0,0,0,1.906,2.292,10.981,10.981,0,0,0,4.148,0,.875.875,0,0,1,.22,1.736,12.343,12.343,0,0,1-4.855-.054,4.264,4.264,0,0,1-3.141-3.637c-.322-1.643-.989-5.358-.991-5.368Zm14.736-3.532a.7.7,0,0,1,1.367.313l-.663,2.888,3.631,5.866a.7.7,0,0,1-1.192.736l-2.885-4.661-.429,1.868a.7.7,0,0,1-1.367-.313l1.537-6.7Zm-7.232,7.177h3.755a1.405,1.405,0,0,1,1.378,1.13l1.833,6.273a1.4,1.4,0,0,1-2.69.779l-1.57-5.372h-4.448l1.74-2.811Z",
    transform: "translate(-163.212 -145.57)",
    fill: "#727376",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.71cabef4698cd6e068ea4fdb332a3041.svg";
export { ForwardRef as ReactComponent };